export default class Title {
    public id?: number;
    public name_fr?: string;
    public name_en?: string;
    public name_nl?: string;

    constructor(init?: Partial<Title>) {
        Object.assign(this, init);
    }
}